import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


const CombinedChart = ({ payload, attributes, type, race }: { payload: any, attributes: string[], type: string, race: string }) => {
    // Extract all unique keys from all attributes
    const keys: number[] = Array.from(new Set(attributes.flatMap(attr => payload[attr].items.map((item: any) => parseInt(item.key, 10))))).sort((a, b) => a - b);

    if ((type === 'physicals' || type === 'mentals') && race === 'human') {
        for (let i = keys[keys.length - 1] + 1; i <= 19; i++) {
          if (!keys.includes(i)) {
            keys.push(i);
          }
        }
        for (let i = keys[0] - 1; i >= 9; i--) {
          if (!keys.includes(i)) {
            keys.unshift(i);
          }
        }
    }

    // Prepare the datasets for each attribute

    const bgColors = ['rgba(0,0,255,.5)', 'rgba(255,0,0,.5)', 'rgba(255,255,0,.5)'];
    const borderColors = ['rgba(0,0,255,.5)', 'rgba(255,0,0,.5)', 'rgba(255,255,0,.5)'];
    
    const datasets = attributes.map((attr: any, i: number) => {

      const data: any = keys.map(key => {
        const item = payload[attr].items.find((item: any) => item.key === key);
        return item ? item.probability : null;
      });

      return {
        label: attr.charAt(0).toUpperCase() + attr.slice(1),
        data: data,
        borderColor: bgColors[i],
        backgroundColor: borderColors[i],
        fill: false,
        tension: .2
      };
    });

    const chartData = {
        labels: keys,
        datasets: datasets,
    };

    return <Line data={chartData} options={{
      responsive: true,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {boxWidth: 25}
        },
        tooltip: {
          callbacks: {
            title: () => '',
            label: (ctx: any) => ` ${ctx.dataset.label}: ${ctx.label}`,
            footer: (items: any) => `${items[0].raw}% chance`
          }
        }
      },
      scales: {
        y: {
          title: {
            display: true,
            text: 'Probability'
          },
          ticks: {
            callback: (value: any) => value + '%'
          },
          min: 0
        },
      }
    }} />;
};

export default CombinedChart;